import React from "react";
import {
    FormControl,
    FormLabel,
    Editable,
    useEditableControls,
    EditableInput,
    Input,
    Flex,
    ButtonGroup,
    IconButton
  } from '@chakra-ui/react'
import { CustomEditablenputProps } from "../../../types/form";
import { BsCheck, BsPen, BsX } from "react-icons/bs";

export default function CustomEditableInput({ 
    label, 
    value, 
    id,  
    size,
    className,
    isEditableButtons,
    name,
    formControlProps,
    onChange,
    ...props
}: CustomEditablenputProps) {
    function RenderEditableButtons() {
        const {
            isEditing,
            getSubmitButtonProps,
            getCancelButtonProps,
            getEditButtonProps,
        } = useEditableControls();

        return isEditing ? (
            <ButtonGroup justifyContent='center' size='sm'>
                <IconButton variant={'ghost'} width={'16px'}  height={'16px'} size='sm' as={BsCheck} aria-label='check' {...getSubmitButtonProps()} />
                <IconButton variant={'ghost'} width={'16px'}  height={'16px'} size='sm' as={BsX} aria-label='cancel' {...getCancelButtonProps()} />
            </ButtonGroup>
            ) : (
            <IconButton variant={'ghost'} size='sm' width={'16px'}  height={'16px'} as={BsPen} aria-label='edit' {...getEditButtonProps()} />
        )
    }

    const focusStyles = {
        boxShadow: 'none !important', 
        border: 'none !important', 
        bg: 'transparent', 
    }
      
    return (
        <FormControl className={className} {...formControlProps}>
            <FormLabel 
                htmlFor={id} 
                fontSize={'sm' || props.fontSize} 
                color='rgba(51, 65, 85, 1)' 
                marginBottom={'0.5' || props?.marginBottom}
            >
                {label}
            </FormLabel>
            <Editable 
                defaultValue={value} 
                display='flex' 
                alignItems={'center'}
                borderRadius={'md'}
                borderWidth={'1px'}
                size={size || 'sm'}
                borderStyle='solid'
                borderColor={'gray.200'}
                padding='1'
                placeholder={props.placeholder}
                fontSize={'sm' || props.fontSize} 
                justifyContent={'space-between'}
                width={'full'}
                value={value}
            >
                <Flex width={'full'}>
                    {isEditableButtons ? (
                        <>
                            <Input 
                                width={'full'}
                                as={EditableInput} 
                                borderRadius={'md'}
                                borderWidth={'1px'}
                                borderStyle='solid'
                                borderColor={'gray.200'}
                                color={'gray.500'} 
                                value={value}
                                paddingLeft={'1'}
                                paddingRight={'1'}
                                onChange={onChange}
                                _focus={focusStyles}
                            />
                            <RenderEditableButtons />
                         </>
                    ): (
                        <Input 
                            width={'full'}
                            border='none'
                            size={'sm'}
                            color={'gray.500'} 
                            outline='none'
                            placeholder={props.placeholder}
                            _focus={focusStyles}
                            onChange={onChange}
                            hidden={false}
                        />
                    )}
                </Flex>
            </Editable>
        </FormControl>       
    )
}